import { atom } from 'recoil';

export const exportingFileNameDocumentsCenter = atom({
  key: 'exportingFileNameDocumentsCenter',
  default: '',
});
